import React from "react";
import { useNavigate, Link } from 'react-router-dom';
import Header from "../Component/Header";
import AdminHeader from "../Component/AdminHeader";
import Footer from "../Component/Footer";
import SubMenu from "../Component/SubMenu";
import { useContext } from 'react';
import { ArgContext } from '../../Context/ArgProvider';

import mainBg from "../../assets/img/bg-esg-02.jpg";


function EnviroMgmt() {
	// 화면 이동을 위한 네비게이터 설정
	const navigate = useNavigate();

	// 일반 또는 관리자 header 설정
	const { argInfo } = useContext(ArgContext);
	const isAdmin = argInfo?.role === 'admin';

    return (<>
	<main className="page-wrapper">
			{isAdmin ? <AdminHeader /> : <Header />}
			{/* <!-- 메인 미이지 + 슬로건 --> */}
			<section className="sub-bannerWrap comOverview-banner" style={{backgroundImage: `url(`+mainBg+`)`}} >
					<div className="textBox">
						<h2>환경경영</h2>
						<p>위피아는 지속가능한 경영을 위해 사회적 역할과 책임을 다하고 신뢰받는 기업이 되기 위해 노력합니다.</p>
					</div>
					<SubMenu />
			</section>
		
			
			{/* 환경경영 */}
			<section className="esg-visoinObj">
				<div className="container-auto sec-mt title-box">
					<h3 className="sub-title">환경경영</h3>
					<p className="sub-text">위피아는 환경 영향을 최소화하고 자원 절감과 에너지의 효율적 이용을 위해 임직원, 고객 등 이해관계자와 함께 환경경영을 실천하여 지속가능한 발전을 도모한다.</p>
				</div>

				<div className="bg-blue sec-py">
					<div className="container-auto">
						<ul className="enviro-list">
							<li>
								<p className="num">01</p>
								<p className="text">기후 위기는 지구환경 보전을 위한 인류의 숙원 과제임을 인식하고, 자원과 에너지 절감으로 온실가스 발생을 최소화하기 위하여 노력한다.</p>
							</li>
							<li>
								<p className="num">02</p>
								<p className="text">환경 관련 국내 법규 및 정책을 성실히 이행한다.</p>
							</li>
							<li>
								<p className="num">03</p>
								<p className="text">환경경영 목표 및 추진계획을 세우고 성과를 평가함으로써 지속적인 개선이 이루어지도록 한다.</p>
							</li>
							<li>
								<p className="num">04</p>
								<p className="text">환경경영에 필요한 물적 자원을 지원하고 체계적인 관리시스템을 운영하여 성과 향상에 노력한다.</p>
							</li>
							<li>
								<p className="num">05</p>
								<p className="text">환경경영활동을 이해관계자에게 공유하고 환경인식 내재화 및 친환경 문화 확산에 동참한다.</p>
							</li>
							<li>
								<p className="num">06</p>
								<p className="text">기업의 사회적 책임에 대하여 깊이 인식하고 지역사회 환경보전활동에 적극 참여한다.</p>
							</li>
						</ul>
						<div className="signWrap">
							<p className="ceo">㈜위피아 대표이사 김용연 <span className="sign">대표이사 사인</span></p>
						</div>
					</div>
				</div>
			</section>

			{/* 경영전략 및 목표 */}
			<section className="enviro-mgmt-wrap">
				 <div className="container-auto sec-my">
						<p className="sub-title">환경을 위한 경영전략 및 목표</p>
						<div className="enviro-mgmt-list">
								<p className="title">
								<span className="tit">경영전략</span>
								<span className="dot"></span>
								<span className="dot dot02"></span>
							</p>
							<ul className="list">
								<li>
									<p className="tit">에너지 자원</p>
									<p className="txt">에너지 자원의 효율적 관리를 통한 환경 경영 실천</p>
								</li>
								<li>
									<p className="tit">환경경영 교육</p>
									<p className="txt">환경경영 교육을 통한 임직원의 환경 의식 정착 및 변화 추진</p>
								</li>
								<li>
									<p className="tit">온실가스 최소화</p>
									<p className="txt">다양한 기후 변화 위기 대응을 통한 온실가스 배출량 최소화</p>
								</li>
								<li>
									<p className="tit">관리체계구축</p>
									<p className="txt">환경법규 위반 및 환경사고 발생에 대한 예방 관리 체계 구축</p>
								</li>
							</ul>
						</div>
						
				 </div>
				 <div className="bg-blue sec-py">
				 	<div className="container-auto">
						<div className="enviro-mgmt-list enviro-mgmt-list2">
							<p className="title">
								<span className="tit">경영목표</span>
								<span className="dot"></span>
								<span className="dot dot02"></span>
							</p>
							<ul className="list">
								<li>
									<p className="tit">개인 목표</p>
									<p className="txt">1인 1개이상 참여</p>
								</li>
								<li>
									<p className="tit">에너지 절감</p>
									<p className="txt">전년대비 에너지 사용량 3% 절감 (2022년대비 2030년까지 20% 절감)</p>
								</li>
								<li>
									<p className="tit">온실가스 배출량 절감</p>
									<p className="txt">전년대비 온실가스 배출량 3% 절감 (2022년대비 2030년까지 20% 절감)</p>
								</li>
								<li>
									<p className="tit">환경 법규 준수</p>
									<p className="txt">환경 법규 위반 0건</p>
								</li>
							</ul>
						</div>
						
					</div>
				 </div>
			</section>
		</main>
	<Footer />
	</>
    );
}

export default EnviroMgmt;